<template>
    <div
        class="w-full"
        style="background-color: #01798A;"
    >
        <div class="hidden max-w-7xl mx-10 pt-12 pb-4 md:flex 2xl:mx-auto">
            <div
                class="rounded-lg"
                style="background-color: #E6F2F3;"
            >
                <h1 class="pt-10 pb-8 pl-6 text-4xl ml-4">
                    Pristilbud
                </h1>
                <div class="flex">
                    <div class="w-1/2 flex flex-col">
                        <div class="ml-10 mt-6 p-4 bg-white rounded-lg flex justify-between">
                            <h2 class="text-xl font-semibold">
                                Totalpris
                            </h2>
                            <p class="text-xl font-semibold">
                                {{ (proposal.amount_pr_pax * (nights)) }},- per person
                            </p>
                        </div>
                        <div class="ml-10 p-4 my-6 bg-white rounded-lg flex flex-col">
                            <h2 class="p-4 font-semibold text-xl">
                                Totalprisen inkluderer
                            </h2>
                            <div class="w-full grid grid-cols-2">
                                <ul
                                    v-for="list in lists"
                                    class="list-disc pl-10"
                                >
                                    <li class="">
                                        {{ list.item }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            v-for="extra in extras"
                            class="ml-10 h-12 items-center flex bg-white rounded-lg"
                        >
                            <div class="h-full w-2/3 border-r flex items-center ml-4 lg:w-1/2">
                                <svg
                                    width="18"
                                    height="17"
                                    class="mr-2"
                                    viewBox="0 0 18 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.00002 1L3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16H14C14.4603 16 14.8334 15.6269 14.8334 15.1667V6.83333L9.00002 1Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M1.5 8.5L3.16667 6.83333M3.16667 6.83333L9.00002 1L14.8334 6.83333M3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002M14.8334 6.83333L16.5 8.5M14.8334 6.83333V15.1667C14.8334 15.6269 14.4603 16 14 16H11.5M6.50002 16C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16M6.50002 16H11.5"
                                        stroke="#212121"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <p class="text-md font-semibold">
                                    Tillegg for {{ extra.room }}
                                </p>
                            </div>
                            <div class="w-1/3 flex justify-end mr-4 lg:w-1/2">
                                <p class="text-md font-semibold">
                                    + {{ extra.priceRoom }},- per person
                                </p>
                            </div>
                        </div>
                        <div
                            v-for="extra in extras"
                            class="ml-10 my-6 h-12 items-center flex bg-white rounded-lg"
                        >
                            <div class="h-full w-2/3 border-r flex items-center ml-4 lg:w-1/2">
                                <svg
                                    width="18"
                                    height="17"
                                    class="mr-2"
                                    viewBox="0 0 18 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.00002 1L3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16H14C14.4603 16 14.8334 15.6269 14.8334 15.1667V6.83333L9.00002 1Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M1.5 8.5L3.16667 6.83333M3.16667 6.83333L9.00002 1L14.8334 6.83333M3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002M14.8334 6.83333L16.5 8.5M14.8334 6.83333V15.1667C14.8334 15.6269 14.4603 16 14 16H11.5M6.50002 16C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16M6.50002 16H11.5"
                                        stroke="#212121"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <p class="text-md font-semibold">
                                    Tillegg for {{ extra.activity }}
                                </p>
                            </div>
                            <div class="w-1/3 flex justify-end mr-4 lg:w-1/2">
                                <p class="text-md font-semibold">
                                    + {{ extra.priceActivity }},- per person
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-for="summary in summaries"
                        class="flex w-1/2"
                    >
                        <div class="mx-8 my-6 p-4 bg-white rounded-lg flex flex-col">
                            <h2 class="p-4 font-semibold text-xl">
                                Sammendrag
                            </h2>
                            <div class="flex w-2/3 justify-between px-4">
                                <p class="text-md">
                                    Antall Reisende
                                </p>
                                <p class="font-semibold">
                                    {{ proposal.pax }}
                                </p>
                            </div>
                            <div class="flex w-2/3 justify-between px-4 mt-3">
                                <p class="text-md">
                                    Antall netter
                                </p>
                                <p class="font-semibold">
                                    {{ nights }}
                                </p>
                            </div>
                            <div class="p-4 mt-2">
                                <p
                                    :class="{ 'border border-gray-600 rounded-md' : editable }"
                                    class="w-full border-none text-sm"
                                    :contenteditable="editable"
                                    @click="makeEditable"
                                    @blur="notEditable"
                                >
                                    {{ summary.text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-20 2xl:mx-auto">
            <div
                v-if="guide"
                class="hidden h-38 mt-6 bg-white rounded-lg md:flex"
            >
                <div class="h-full w-1/2 p-7 border-r flex items-center">
                    <figure>
                        <img
                            :src="proposal.creator.profile_photo_url"
                            :alt="proposal.creator.name"
                            class="ml-10 h-32 w-32 rounded-full"
                        >
                    </figure>
                    <div class="flex flex-col ml-10">
                        <p class="mb-4">
                            Med vennlig hilsen
                        </p>
                        <p class="font-semibold">
                            {{ proposal.creator.name }}
                        </p>
                        <p class="font-semibold underline">
                            {{ guide.phone }}
                        </p>
                        <p class="font-semibold underline">
                            {{ proposal.creator.email }}
                        </p>
                    </div>
                </div>
                <div
                    v-if="company"
                    class="h-full w-1/2 p-7 flex-col"
                >
                    <p class="mt-12">
                        Org.nr {{ company.org }}
                    </p>
                    <p>Tilbudet er levert av: {{ proposal.project.team.name }} </p>
                    <a
                        href="#"
                        class="underline-none"
                    >Personvern og Cookies</a>
                </div>
            </div>
        </div>
        <div class="hidden w-full justify-center py-10 md:flex">
            <button
                type="button"
                class="border border-white p-2 rounded-lg text-white text-sm"
            >
                Gå til oversikten
            </button>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";

const props = defineProps({
    proposal: {
        type: Object,
        required: true
    },
})

const start = new Date(props.proposal.start_date)
const end = new Date(props.proposal.end_date)
const nights = ((((end - start) / 1000 ) / 60 ) / 60 ) / 24

const editable = ref(false)

const lists = [
    {
        item: 'Fly t/r',
    },
    {
        item: 'SanRemo bar',
    },
    {
        item: 'sdfsdf',
    },
    {
        item: 'Fly t/r',
    },
];

const extras = [
    {
        room: 'enkeltrom',
        priceRoom: '1590',
        activity: 'Tanks',
        priceActivity: '390',
    },
];

const summaries = [
    {
        text: 'Forslaget tar utgangspunkt i en gruppe på 12 personer og er inklusive skatter og avgifter.Det tas forbehold om endringer i skatter og avgifter samt valutakurser. Fly og hotell er reservert, mens resten av program kan ikke bekreftes før det eventuelt foreligger bekreftet tur.'
    },
];

const guide = {
    name: 'Gustav Henriksen',
    phone: '+47 987 65 432',
    mail: 'gustav@firmatur.no',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80',
    alt: 'photo of guide',
};

const company = {
    org: '987 654 321',
    name: 'Firmatur AS',
};


function makeEditable() {
    editable.value = true
}

function notEditable() {
    editable.value = false
}

</script>
